import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandedRowHeader } from '../../expandedRow/header/expandedRowHeader.component';
import { AnalysisImportComponent } from '../import/analysisImport.component';
import { AnalysisViewComponent } from '../view/analysisView.component';
import Style from './analysisSection.module.css';
import { StudyRoleClaimValue } from 'src/services/api/api-client';
import { PatientCardContext } from 'src/components/expandedRow/PatientCardContext';
import { IssueMark } from 'src/components/issue/issueTarget/issueMark.component';
import PropertiesList from 'uikit/propertiesList/PropertiesList';
import { useGetAllAnalysisPresetsForStudyQuery } from 'src/services/api/api-client/AnalyzesQuery';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useHasStudyClaims } from 'src/helpers/auth/auth-helper';

export const AnalysisSection = () => {
  const study = useStudy();
  const { t } = useTranslation();
  const { hasOneOfStudyClaims, hasStudyClaim } = useHasStudyClaims();
  const { patient } = useContext(PatientCardContext);
  const hasPermissions = hasOneOfStudyClaims(StudyRoleClaimValue.AnalysisPresetView, StudyRoleClaimValue.AnalysisView);
  const { data: analysisPresets } = useGetAllAnalysisPresetsForStudyQuery(study?.id, {
    enabled: hasPermissions,
  });

  return (
    <div data-test-id={'patient-card-analysis'}>
      <IssueMark
        issueContext={{
          subject: 'Patient',
          topic: 'Analyzes',
          linkedPatientUniqId: patient.uniqueId,
        }}
      >
        <ExpandedRowHeader text={t('ExternalAnalysis.Presets.SectionHeader')} />
      </IssueMark>

      <PropertiesList className={Style.container}>
        {hasPermissions &&
          analysisPresets?.map((presetDto) => (
            <PropertiesList.Property
              key={presetDto.id}
              name={presetDto.name}
              value={
                <div className={Style.tableItemRightContainer}>
                  {hasStudyClaim(StudyRoleClaimValue.AnalysisView) && (
                    <AnalysisViewComponent
                      key={`view_${presetDto.id}`}
                      title={presetDto.name}
                      patientId={patient.id}
                      presetId={presetDto.id}
                    />
                  )}
                  {hasStudyClaim(StudyRoleClaimValue.AnalysisManage) && (
                    <AnalysisImportComponent key={`import_${presetDto.id}`} preset={presetDto} patientId={patient.id} />
                  )}
                </div>
              }
            />
          ))}
      </PropertiesList>
    </div>
  );
};
